import { w } from '@tinkoff/statist-page-data';
import { parseUrl, resolvePreviousPage, referrer } from '@tinkoff/statist-page-data/browser';
import { tBankInternalDomains } from '@tinkoff/statist-page-data/tbank';
export function getReferrer() {
    var location = parseUrl(w.location.href);
    return resolvePreviousPage({
        location: location,
        referrer: referrer(),
        internalDomains: tBankInternalDomains,
    });
}
//# sourceMappingURL=referrer.js.map